// src/components/course/CourseSearchBar.js
import React from "react";
import { Search } from "lucide-react";

function CourseSearchBar({
  value,
  onChange,
  onSearch,
  placeholder = "코스 이름, 위치 등을 검색하세요",
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch && onSearch();
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="relative">
        {/* 아이콘 */}
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
          <Search className="w-5 h-5" />
        </div>

        {/* 입력창: bg-gray-100 + shadow-inner (안쪽 그림자) 적용 */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-12 pl-11 pr-4 rounded-xl bg-gray-100 shadow-inner border-none text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[rgb(0,224,198)] transition-all"
        />
      </div>
    </form>
  );
}

export default CourseSearchBar;
